type PopupType = 'login' | 'download';

interface PopupConfig {
    maxLoginPopupCount?: number;
    maxDownloadPopupCount?: number;
}

interface PopupState {
    currentLoginPopupCount: number;
    currentDownloadPopupCount: number;
}

/**
 * @description 弹窗弹出管理器，目前支持登录和下载 时机时主动弹出订阅弹窗
 */
class PopupManager {
    private static instance: PopupManager;
    private maxLoginPopupCount: number = 1;
    private maxDownloadPopupCount: number = 1;
    private state: PopupState = {
        currentLoginPopupCount: 0,
        currentDownloadPopupCount: 0,
    };

    // 私有构造函数，防止外部实例化
    private constructor() {
        if (typeof window !== 'undefined') {
            // 仅在客户端环境中访问 localStorage
            const savedState = localStorage.getItem('popupState');
            if (savedState) {
                this.state = JSON.parse(savedState);
            } else {
                this.updateState();
            }
        }
    }
    // 获取单例实例
    public static getInstance(): PopupManager {
        if (!PopupManager.instance) {
            PopupManager.instance = new PopupManager();
        }
        return PopupManager.instance;
    }

    // 设置配置方法
    /**
   * @description 设置配置方法
   * @param config PopupConfig
   * @example
   * 
   *      //项目初始化的时候
   *      setConfig({
   *        maxLoginPopupCount: 1, // 最大登录弹窗次数
            maxDownloadPopupCount: 1, // 最大下载弹窗次数
   *      })
   */
    public setConfig(config: PopupConfig) {
        const { maxLoginPopupCount, maxDownloadPopupCount } = config;
        if (maxLoginPopupCount !== undefined) {
            this.maxLoginPopupCount = maxLoginPopupCount;
        }
        if (maxDownloadPopupCount !== undefined) {
            this.maxDownloadPopupCount = maxDownloadPopupCount;
        }
    }

    // 更新并保存状态到 localStorage
    private updateState() {
        localStorage.setItem('popupState', JSON.stringify(this.state));
    }

    /**
   * @description 弹出处理方法
   * @param popupType 
   * @param callback 
   * @example
   *     在需要主动弹出订阅时调用
   *     popupManager.handlePopup("login", () => {
   *        // 弹出订阅窗口 逻辑，比如 (openVipModal 是业务方打开订阅窗口公共方法)
   *        openVipModal({
              entrance: xxxx,
              source: xxxx,
              trackEntrance: xxxxx,
            })
   *     })
   */
    public handlePopup(popupType: PopupType, callback: () => void) {
        if (popupType === 'login') {
            if (this.state.currentLoginPopupCount < this.maxLoginPopupCount) {
                this.state.currentLoginPopupCount++;
                this.updateState();
                callback();
            }
        } else if (popupType === 'download') {
            if (this.state.currentDownloadPopupCount < this.maxDownloadPopupCount) {
                this.state.currentDownloadPopupCount++;
                this.updateState();
                callback();
            }
        }
    }

    /**
     * @description 退出登录清空数据
     * @example
     *      //退出登录时调用
     *      popupManager.logout()
     */
    public logout() {
        if (typeof window !== 'undefined') {
            localStorage.removeItem('popupState');
        }
        this.state = {
            currentLoginPopupCount: 0,
            currentDownloadPopupCount: 0,
        };
    }
}
const popupManager = PopupManager.getInstance();
export default popupManager;
